import { Box, Typography, Picture } from "@jewlr/storybook/core"
import styled from "styled-components"

import { TitleWithLine } from "../jewlr/components"

import { TextColored } from "./components"

const Title = styled(TitleWithLine)`
  background-position: center bottom;
  background-size: 25% 1px;
  text-align: center;
  ${(props) => props.theme.mediaQueries.tablet`
     background-position: left bottom;
     background-size: 33% 1px;
     text-align: left;
  `}
`
const PeaceOfMind = () => (
  <Box mb={4}>
    <TitleWithLine>Simple Peace-Of-Mind Protection</TitleWithLine>
    <Typography mb={5} px={{ _: 4, desktop: "170px" }} textAlign="center">
      You pay one flat rate at checkout and when you need it, Extend will work
      directly with us to get your product repaired quickly. Getting your
      replacement is seamless and simple.
    </Typography>
    <Box alignItems="center" display={{ _: "block", tablet: "flex" }}>
      <Box flex="1 1 30%" textAlign="center">
        <Title>What If I Need To Make A Claim</Title>
        <Typography
          mb={5}
          px={{ _: 4, tablet: 0 }}
          textAlign={{ _: "center", tablet: "left" }}
        >
          Processing your claim takes minutes and you’ll receive everything you
          need for a repair or replacement. Simply{" "}
          <TextColored
            as="a"
            href="https://customers.extend.com/"
            target="_blank"
          >
            contact Extend
          </TextColored>{" "}
          online or by phone at{" "}
          <TextColored as="a" href="tel:877-248-7707">
            (877) 248-7707
          </TextColored>
          . Easy as pie!
        </Typography>
      </Box>
      <Box flex="1 1 70%">
        <Picture
          alt="Texting"
          fallback={require("images/info/warranty/texting.png")}
          lazyload={false}
          srcSet={[
            {
              height: "890",
              media: "(max-width: 767px)",
              sizes: "100vw",
              srcSet: `
              ${require("images/info/warranty/texting-mobile.png")} 640w,
            `,
              width: "640",
            },
            {
              height: "914",
              media: "(min-width:  768px)",
              sizes: "100vw",
              srcSet: `
              ${require("images/info/warranty/texting.png")} 1380w,
            `,
              width: "1380",
            },
          ]}
        />
      </Box>
    </Box>
  </Box>
)

export default PeaceOfMind
